<template>
  <div>
    <HeadBar />
    <HeadNav />
    <div class="con">
      <div class="con-inner flex flex-row">
        <StandardFileList />
        <RankLists />
      </div>
    </div>
    <FootBar />
  </div>
</template>

<script>
import StandardFileList from "./components/standardFileList";
import RankLists from "./components/rankLists";
export default {
  components: {
    StandardFileList,
    RankLists,
  },

  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/style/variable";
.con {
  background: #f5f5f5;
  min-height: 550px;
  padding-top: 20px;
  padding-bottom: 5px;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    margin-bottom: 25px;
    display: grid;
    grid-template-columns: calc(70% - 20px) 30%;
    gap: 20px;
  }
}
</style>
